// extracted by mini-css-extract-plugin
module.exports = {"suspensionPanel":"ysgG2EDi","launchBottomShow":"BzNBb_mH"};